import React from 'react';
import { useDispatch } from 'react-redux';
import ConsultantsWithAccess from './ConsultantsWithAccess';
import ConsultantsWithAccessForm from './ConsultantsWithAccessForm';
import { handleError } from '../store/features/alertSlice';
import claimGroupRolesService from '../services/claim_groups/claimGroupRoles.service';
export default function SelectConsultants(_ref) {
  let {
    claimGroup,
    claimGroupId = null,
    consultantsAndAdmins,
    removeConsultantFromClaim,
    onClaimGroupConsultantRolesChange,
    size = 'sm',
    isUnderReview,
    pageAccess
  } = _ref;
  const groupId = claimGroup.id || claimGroupId;
  const consultants = claimGroup.consultants || claimGroup.consultants_attributes || claimGroup.consultant_roles;
  const leadConsultantExists = consultants.find(consultant => consultant.role === 'claim_group_access_lead_consultant');
  const dispatch = useDispatch();
  const removeConsultantFromExistingClaimGroup = async consultant => {
    try {
      // returns a claim group
      const claimGroupResult = await claimGroupRolesService.delete(groupId, consultant.user.id, consultant.role);
      onClaimGroupConsultantRolesChange(claimGroupResult);
    } catch (error) {
      dispatch(handleError(error));
    }
  };
  const updateConsultantRolesExistingClaimGroup = async consultant => {
    if (consultant.role === 'claim_group_access_lead_consultant' && leadConsultantExists) {
      if (!window.confirm('This will override the current lead consultant')) {
        return;
      }
    }
    try {
      // returns a claim group
      const claimGroupResult = await claimGroupRolesService.create(groupId, consultant.id, consultant.role);
      onClaimGroupConsultantRolesChange(claimGroupResult);
    } catch (error) {
      console.log(error);
      dispatch(handleError(error));
    }
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ConsultantsWithAccess, {
    consultants: consultants,
    claimGroup: claimGroup,
    removeConsultantFromClaim: groupId ? removeConsultantFromExistingClaimGroup : removeConsultantFromClaim,
    canRemoveConsultant: !pageAccess || pageAccess.canEditConsultants,
    size: size,
    isUnderReview: isUnderReview
  })), (!pageAccess || pageAccess.canEditConsultants) && /*#__PURE__*/React.createElement(ConsultantsWithAccessForm, {
    consultantsAndAdmins: consultantsAndAdmins,
    claimGroup: claimGroup,
    handleConsultantToClaimGroupCreate: groupId ? updateConsultantRolesExistingClaimGroup : onClaimGroupConsultantRolesChange,
    size: size,
    isUnderReview: isUnderReview
  }));
}